<template>
  <div class="container">
    <div class="control">
      <div class="col-md-8">
        <div class="">
          <div class="">{{logReg}}</div>
          <div class="">
            <transition name='fade'>
              <div class="row">
                <div v-if="msg" :class="{'alert-danger':isError}" class="alert col-md-6">{{msg}}</div>
              </div>
            </transition>
            <form action="#" @submit.prevent="submit">
              <div class="field">
                <label for="email" class="label">Email</label>

                <div class="control">
                  <input
                    id="email"
                    type="email"
                    class="input"
                    name="email"
                    value
                    required
                    autofocus
                    v-model="form.email"
                  />
                </div>
              </div>

              <div class="field">
                <label for="password" class="label">Password</label>

                <div class="control">
                  <input
                    id="password"
                    type="password"
                    class="input"
                    name="password"
                    required
                    v-model="form.password"
                  />
                </div>
              </div>
              <transition name='fade'>
                <div v-if="pass2Active" class ='field'>
                  <label for="password2" class="label">Confirm Password</label>

                  <div class="control">
                    <input
                      id="password2"
                      type="password"
                      ref= "password"
                      class="input"
                      name="password2"
                      required
                      v-model="form.password2"
                    />
                  </div>
                </div>
              </transition>
              <div class="field">
                <div class="control">
                  <button id="loginBtn" type="submit" class="button">{{logReg}}</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase'
export default {
  data () {
    return {
      logReg: 'Login',
      allowReg: null,
      pass2Active: false,
      form: {
        email: '',
        password: '',
        password2: ''
      },
      isError: null,
      msg: ''
    }
  },
  props: {
  },
  methods: {
    submit () {
      firebase
        .auth()
        .signInWithEmailAndPassword(this.form.email, this.form.password)
        .then(data => {
          var user = firebase.auth().currentUser
          localStorage.setItem('user', user.uid)
          this.$router.push({
            name: 'Intro',
            params: {
              email: this.form.email
            }
          })
        })
        .catch(err => {
          // Unregistered & using predefined password from config.js?
          if (err.code === 'auth/user-not-found' && this.form.password === this.$root.config.predefinedPassword) {
            this.isError = null
            this.msg = 'Welcome new reader, please set your password'
            this.logReg = 'Register'
            this.form.password = ''
            this.allowReg = true
            this.pass2Active = true
          } else if (err.code === 'auth/user-not-found' && this.allowReg === true) {
            if (this.form.password === this.form.password2) {
              // Passwords match register user
              this.allowReg = null
              firebase
                .auth()
                .createUserWithEmailAndPassword(this.form.email, this.form.password)
                .then(data => {
                  // Set current uid in local storage
                  localStorage.setItem('user', data.user.uid)
                  // Update user info with email as display name
                  /* data.user
                    .updateProfile({
                      displayName: this.form.email
                    }) */
                  this.$router.push({
                    name: 'Intro',
                    params: {
                      email: this.form.email
                    }
                  })
                })
                .catch(err => {
                  this.isError = true
                  this.msg = err.message
                })
            } else {
              // Misaligned passwords
              this.isError = true
              this.msg = 'Please ensure your passwords match'
            }
          } else {
            this.isError = true
            this.msg = err.message
          }
        })
    }
  }
}
</script>

<style lang="css" scoped>
.hidden {
  display: none;
}
</style>
